import { ReactNode } from 'react';

export default function FormSection(props: {
  title: string;
  description?: string;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div className="border-b border-gray-900/10 pb-2">
      <h2 className="text-lg font-semibold leading-7 text-gray-900">
        {props.title}
      </h2>

      {!props.description ? null : (
        <p className="text-sm leading-6 text-gray-600">{props.description}</p>
      )}

      <div className="mt-4 flex flex-col gap-y-4">{props.children}</div>
    </div>
  );
}
